import axiosClient from "@/api/common/axiosClient.ts";
import { PaginatedResponse } from "@/api/types.ts";
import { Notification } from "@/types/notification.ts";

export const getNotifications = () => {
  return axiosClient.get<PaginatedResponse<Notification>>("notifications/me/");
};
